import { DashboardContainerProps } from "../Cards/Interfaces/DashboardContainer";
import { useDashboardSectionManager } from "@/hooks/useDashboardSectionManager";

/**
 * The main resusable container used to render specific sections of the main dashboard
 */
export function MainTopDashboardContainer(props: DashboardContainerProps & { initialSections: string[] }) {
    const { renderFullContainer } = useDashboardSectionManager(props.preferences?.dashboard_layout as string[] ?? [], props.initialSections);

    return (
        <div className="flex flex-col gap-4">
            {renderFullContainer(props)}
        </div>
    )
}

// If the section isn't showing, make sure the local storage has the correct preferences and on the backend
export function EstimatorTopDashboardContainer(props: DashboardContainerProps) {
    return (
        <MainTopDashboardContainer {...props} initialSections={["project", "task", "bid"]} />
    )
}

export function FacilitatorTopDashboardContainer(props: DashboardContainerProps) {
    return (
        <MainTopDashboardContainer {...props} initialSections={["project", "task", "mini_project_list"]} />
    )
}

export function PurchaserTopDashboardContainer(props: DashboardContainerProps) {
    return (
        <MainTopDashboardContainer {...props} initialSections={["project", "task", "invoice"]} />
    )
}

export function DesignerTopDashboardContainer(props: DashboardContainerProps) {
    return (
        <MainTopDashboardContainer {...props} initialSections={["project", "task", "mini_project_list"]} />
    )
}

export function ITTopDashboardContainer(props: DashboardContainerProps) {
    return (
        <MainTopDashboardContainer {...props} initialSections={["project", "task"]} />
    )
}

export function AdminTopDashboardContainer(props: DashboardContainerProps) {
    return (
        <MainTopDashboardContainer {...props} initialSections={["project", "task", "bid", "invoice"]} />
    )
}

export function CEOTopDashboardContainer(props: DashboardContainerProps) {
    return (
        <MainTopDashboardContainer {...props} initialSections={["project", "task", "bid"]} />
    )
}